// extracted by mini-css-extract-plugin
export default {"button":"ToggleButton-module__button__c2xil","icon":"ToggleButton-module__icon__AmV-W"};